import { serviceNav } from "../../../config/content.js";
import { serviceRoute } from "../../../config/paths.js";
import { buildAnimatedHeading } from "../../HeroTitleAnimation.js";
import { buildSectionPillRow } from "../../components/SectionPill.js";

function renderItem(item, index) {
  return `
    <details class="services-faq reveal" style="--delay: ${0.08 + index * 0.08}s"${index === 0 ? " open" : ""}>
      <summary class="services-faq__summary">
        <span class="services-faq__question">${item.question}</span>
        <span class="services-faq__icon" aria-hidden="true"></span>
      </summary>
      <div class="services-faq__body">
        <p>${item.answer}</p>
      </div>
    </details>
  `;
}

function renderServiceRail(activeSlug) {
  const items = serviceNav
    .map((item, index) => {
      const href = serviceRoute(item.slug, "faqs");
      const active = item.slug === activeSlug;
      return `
        <li class="services-faqs__rail-item" style="--rail-i: ${index}">
          <a class="services-faqs__rail-link${active ? " is-active" : ""}" href="${href}"${active ? ' aria-current="page"' : ""}>
            <span>${item.label}</span>
            <span class="services-faqs__rail-arrow" aria-hidden="true">→</span>
          </a>
        </li>
      `;
    })
    .join("");

  return `
    <aside class="services-faqs__rail reveal" style="--delay: 0.12s" aria-label="Service FAQs">
      <ul class="services-faqs__rail-list">${items}</ul>
    </aside>
  `;
}

/**
 * @param {object} options
 * @param {boolean} [options.serviceRail]  Show the per-service rail beside the list.
 * @param {string}  [options.activeSlug]   Service whose rail link is highlighted.
 */
export function createServicesFaqsSection(faqs, options = {}) {
  const withRail = Boolean(options.serviceRail);
  const section = document.createElement("section");
  section.id = "faqs";
  section.className = `section services-faqs${withRail ? " services-faqs--with-rail" : ""}`;

  section.innerHTML = `
    <div class="section__inner services-faqs__layout">
      <header class="section__header reveal">
        ${buildSectionPillRow(faqs.badge)}
        <h2>${buildAnimatedHeading(faqs.titleSegments)}</h2>
        <p>${faqs.subtitle}</p>
      </header>
      ${withRail ? renderServiceRail(options.activeSlug) : ""}
      <div class="services-faqs__list">
        ${faqs.items.map(renderItem).join("")}
      </div>
    </div>
  `;

  bindFaqs(section);
  return section;
}

function bindFaqs(section) {
  const items = [...section.querySelectorAll(".services-faq")];

  items.forEach((item) => {
    item.addEventListener("toggle", () => {
      if (!item.open) return;
      items.forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });
}
